import type { ReactElement } from 'react';

interface Props {
    id: string;
    rating: number;
    bigStars?: boolean;
    emptyStars: boolean;
    className?: string;
}

const renderStar = (starType: ReactElement, key: string | number) => (
    <div key={`star${key}`} data-testid="starRating">
        {starType}
    </div>
);

const generateRating = (rating: number, emptyStars = false) => {
    const intRating: number = Math.floor(rating);
    const isHalf: boolean = rating % 1 === 0.5;
    const ratingsCollection: ReactElement[] = [];
    for (let i = 0; i < intRating; ++i) {
        ratingsCollection.push(renderStar(<w-icon name="StarFull" size="small" />, `rating${i}`));
    }

    if (isHalf) {
        ratingsCollection.push(renderStar(<w-icon name="StarHalf" size="small" />, 'rating-half'));
    }

    if (emptyStars) {
        for (let i = intRating + (isHalf ? 1 : 0); i < 5; i++) {
            ratingsCollection.push(renderStar(<w-icon name="StarEmpty" size="small" />, `rating${i}`));
        }
    }

    return ratingsCollection;
};

export const StarRating = ({ id, rating, emptyStars, className }: Props) => (
    <div id={`${id}-rating`} className={`flex ${className ?? ''}`}>
        <label htmlFor={`${id}-rating`} className="sr-only">
            {rating} stjerners hotell
        </label>
        {generateRating(rating, emptyStars)}
    </div>
);
